import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslationKeys} from '../../../constants/TranslationKeys';
import {FinalizeRegistrationNewRequest} from '../../../models/FinalizeRegistrationRequest';
import {LocalizableError} from '../../../models/LocalizableError';
import {EVENT_SERVICE} from '../../../providers/service.providers';
import {EventService} from '../../../services/event.service';

@Component({
  selector: 'app-registration.finalize',
  templateUrl: './registration.finalize.html'
})
export class RegistrationFinalizeComponent implements OnInit {
  public error: LocalizableError;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(EVENT_SERVICE) private eventService: EventService,
  ) { }

  registrationInProgress: boolean;
  private readableEventId: string;

  ngOnInit() {
    this.readableEventId = this.route.snapshot.queryParams['id'];
    this.registrationInProgress = true;
    const payload: FinalizeRegistrationNewRequest = {
      payerId: this.route.snapshot.queryParams['PayerID'],
      paymentId: this.route.snapshot.queryParams['paymentId'],
      purchaseId: this.route.snapshot.queryParams['purchaseId'],
    };

    this.eventService.finalizeRegistrationNew(this.readableEventId, payload).subscribe((registrationResult) => {
      if (registrationResult.status === 'Success') {
        this.router.navigate(['../../confirmation'], {
          relativeTo: this.route,
          queryParams: {
            id: this.readableEventId
          }
        });
      } else {
        this.error = new LocalizableError(registrationResult.errorMessage, TranslationKeys.RegistrationFailed);
      }
    }, (error: LocalizableError) => this.handleErrorResponse(error))
      .add(() => {
        this.registrationInProgress = false;
      });

  }

  private handleErrorResponse(error: LocalizableError) {
    this.error = error;
  }

}
